import { deleteCustomerPaymentCardBackend } from "../api/backend";
import store from "../redux/store";
import { TEXT_VALIDATION_USE_CB } from "../constants";
import {
  retrieveCard,
  updateCustomerPaymentCardBackend,
  updateDefaultCard,
} from "../api";
import { showMessageModal, showPaymentModal } from "../redux/actions";
import {
  logLowError,
  logLowLog,
  logMediumError,
  logMediumLog,
} from "../utils/logger";
import _ from "lodash";
import { openMessageModal } from "./common";
import { UPDATE_PROFILE } from '../redux/actions/types'
type ChangeDefaultCreditCardParams = {
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedCard: React.Dispatch<React.SetStateAction<any>>;
  newCardId: any;
};

export const deleteCB = async (cardId: any) => {
  try {
    await deleteCustomerPaymentCardBackend(cardId);

    const { user } = store.getState().userReducer;

    const updatedCards = _.filter(
      user.cards,
      (c: any) => c?.id !== cardId
    );

    store.dispatch({
      type: UPDATE_PROFILE,
      payload: {
        attribute: "cards",
        value: updatedCards,
      },
    });

    if (updatedCards.length === 1) {
      await changeDefaultCreditCard({
        setLoading: () => { },
        setSelectedCard: () => { },
        newCardId: updatedCards[0].id,
      });
    }

    openMessageModal(
      `Nous vous confirmons la suppression de votre carte bancaire`
    );
  } catch (error) {
    openMessageModal(
      `Nous n'avons pas pu supprimer votre carte bancaire, veuillez essayer de nouveau.`
    );
    logLowError(`Error deleting user CB ${error}`);
  }
};
export const changeDefaultCreditCard = async ({
  setLoading,
  setSelectedCard,
  newCardId,
}: ChangeDefaultCreditCardParams) => {
  try {
    logLowLog(`Updating default card to ${newCardId}`);
    const { user, userConnected } = store.getState().userReducer;
    const { customerId } = user;
    setLoading(true);
    if (userConnected) {
      const { stripeCustomerId } = user;
      const card = await retrieveCard({
        cardId: newCardId,
        customerId,
      });
      if (card?.customer) {
        logMediumLog("Updating default source on stripe");
        await updateDefaultCard({
          cardId: newCardId,
          stripeCustomerId,
          customerId,
        });
      }
      await updateCustomerPaymentCardBackend(newCardId);
    }
    setLoading(false);
    store.dispatch(showPaymentModal(false));
  } catch (error) {
    logMediumError(`Error updating default credit card: ${error}`);
    openMessageModal(
      "Nous n'avons pas pu modifier votre carte par défaut. Veuillez réessayer ou ajouter une nouvelle carte bancaire."
    )
    setLoading(false);
  }
};

export const updateCb = async (
  cardId,
  setLoading,
  setSelectedCard,
  setSelected
) => {
  store.dispatch(
    showMessageModal(TEXT_VALIDATION_USE_CB, {
      onClick: async () => {
        await changeDefaultCreditCard({
          setLoading,
          setSelectedCard,
          newCardId: cardId,
        });

        setSelected(cardId);
        store.dispatch(showMessageModal(null));
      },
      showCancel: true,
      image: "card",
      text: 'DÉFINIR COMME CARTE PAR DÉFAUT',
      withImage: true,
      subTitle: TEXT_VALIDATION_USE_CB,
      buttonName: 'Définir par défaut',
      maxWidth: 480,
      secondaryButtonSx: { maxWidth: 150 }
    })
  );
};

export const sortedMethods = (cards) => {
  return _.orderBy(
    _.map(cards, (card: any) => ({
      id: card.id,
      brand: card.brand,
      last4: card.last4,
      expiresText: `Expire le ${card.exp_month.toString().padStart(2, "0")}/${card.exp_year
        }`,
      isDefault: card.selected,
      disabled: false,
    })),
    ["isDefault"],
    ["desc"]
  );
};
